/* Live Custom Belts — parametric belt geometry. Zees Belts original. 2026-09-13 (v3).
   One source of truth for the SVG placeholder and the 3D renderer. Everything is a command
   list that can emit an SVG path string or a THREE.Shape.

   v3 changes: proportions rebuilt to a real championship-belt footprint; the leather is ONE
   seamless silhouette (arms + centre yoke joined analytically, no overlapping meshes); every
   plate is centred on the same belt axis; zone (text) placement is derived from the actual
   plate half-width at that height, and from which stacked tier the zone sits on, so nothing
   can ever overlap the ornament or run off the plate.

   Canvas 1600 x 520. Belt axis y = 260. */
(function (root) {
  'use strict';
  var W = 1600, H = 520, CX = 800, CY = 260;
  var X0 = 26, X1 = W - 26;          // strap ends
  var BH = 86;                        // strap band half-height
  var ENDR = 26;                      // radius on the strap end corners
  var YOKE_W = 234, YOKE_H = 224;     // centre yoke half-size (matches the modelled body)

  /* ---------- path builder ---------- */
  function Path() { this.c = []; }
  Path.prototype.M = function (x, y) { this.c.push([0, x, y]); return this; };
  Path.prototype.L = function (x, y) { this.c.push([1, x, y]); return this; };
  Path.prototype.Q = function (a, b, x, y) { this.c.push([2, a, b, x, y]); return this; };
  Path.prototype.C = function (a, b, c, d, x, y) { this.c.push([3, a, b, c, d, x, y]); return this; };
  Path.prototype.Z = function () { this.c.push([4]); return this; };
  Path.prototype.add = function (p) { this.c = this.c.concat(p.c); return this; };
  Path.prototype.svg = function () {
    return this.c.map(function (s) {
      if (s[0] === 0) return 'M' + f(s[1]) + ' ' + f(s[2]);
      if (s[0] === 1) return 'L' + f(s[1]) + ' ' + f(s[2]);
      if (s[0] === 2) return 'Q' + f(s[1]) + ' ' + f(s[2]) + ' ' + f(s[3]) + ' ' + f(s[4]);
      if (s[0] === 3) return 'C' + f(s[1]) + ' ' + f(s[2]) + ' ' + f(s[3]) + ' ' + f(s[4]) + ' ' + f(s[5]) + ' ' + f(s[6]);
      return 'Z';
    }).join(' ');
  };
  function f(n) { return Math.round(n * 10) / 10; }
  Path.prototype.map = function (fn) {
    var p = new Path();
    p.c = this.c.map(function (s) {
      var t = [s[0]];
      for (var i = 1; i < s.length; i += 2) { var q = fn(s[i], s[i + 1]); t.push(q[0], q[1]); }
      return t;
    });
    return p;
  };
  Path.prototype.mirror = function (cx) { return this.map(function (x, y) { return [2 * (cx === undefined ? CX : cx) - x, y]; }); };
  Path.prototype.scale = function (cx, cy, k, ky) {
    ky = ky === undefined ? k : ky;
    return this.map(function (x, y) { return [cx + (x - cx) * k, cy + (y - cy) * ky]; });
  };
  Path.prototype.bbox = function () {
    var a = [1e9, 1e9, -1e9, -1e9];
    this.c.forEach(function (s) { for (var i = 1; i < s.length; i += 2) { a[0] = Math.min(a[0], s[i]); a[1] = Math.min(a[1], s[i + 1]); a[2] = Math.max(a[2], s[i]); a[3] = Math.max(a[3], s[i + 1]); } });
    return { x: a[0], y: a[1], w: a[2] - a[0], h: a[3] - a[1], cx: (a[0] + a[2]) / 2, cy: (a[1] + a[3]) / 2 };
  };
  function P() { return new Path(); }

  /* flatten a path to a polyline (used for hit-width queries and stitch runs) */
  function flatten(path, per) {
    per = per || 14;
    var out = [], cur = null, start = null;
    path.c.forEach(function (s) {
      if (s[0] === 0) { cur = [s[1], s[2]]; start = cur; out.push(cur); }
      else if (s[0] === 1) { lerpTo(out, cur, [s[1], s[2]], per); cur = [s[1], s[2]]; }
      else if (s[0] === 2) { quadTo(out, cur, [s[1], s[2]], [s[3], s[4]], per); cur = [s[3], s[4]]; }
      else if (s[0] === 3) { cubTo(out, cur, [s[1], s[2]], [s[3], s[4]], [s[5], s[6]], per); cur = [s[5], s[6]]; }
      else if (s[0] === 4 && start) { lerpTo(out, cur, start, per); cur = start; }
    });
    return out;
  }
  function lerpTo(o, a, b, per) {
    var n = Math.max(1, Math.ceil(Math.hypot(b[0] - a[0], b[1] - a[1]) / per));
    for (var i = 1; i <= n; i++) o.push([a[0] + (b[0] - a[0]) * i / n, a[1] + (b[1] - a[1]) * i / n]);
  }
  function quadTo(o, a, c, b, per) {
    var n = Math.max(3, Math.ceil((Math.hypot(c[0] - a[0], c[1] - a[1]) + Math.hypot(b[0] - c[0], b[1] - c[1])) / per));
    for (var i = 1; i <= n; i++) { var t = i / n, m = 1 - t; o.push([m * m * a[0] + 2 * m * t * c[0] + t * t * b[0], m * m * a[1] + 2 * m * t * c[1] + t * t * b[1]]); }
  }
  function cubTo(o, a, c1, c2, b, per) {
    var n = Math.max(4, Math.ceil((Math.hypot(c1[0] - a[0], c1[1] - a[1]) + Math.hypot(c2[0] - c1[0], c2[1] - c1[1]) + Math.hypot(b[0] - c2[0], b[1] - c2[1])) / per));
    for (var i = 1; i <= n; i++) {
      var t = i / n, m = 1 - t;
      o.push([m * m * m * a[0] + 3 * m * m * t * c1[0] + 3 * m * t * t * c2[0] + t * t * t * b[0],
      m * m * m * a[1] + 3 * m * m * t * c1[1] + 3 * m * t * t * c2[1] + t * t * t * b[1]]);
    }
  }
  /* widest horizontal run of the shape at height y (belt units). Returns null if y is outside. */
  function spanAt(poly, y) {
    var xs = [], i, a, b;
    for (i = 0; i < poly.length; i++) {
      a = poly[i]; b = poly[(i + 1) % poly.length];
      if ((a[1] - y) * (b[1] - y) < 0) xs.push(a[0] + (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]));
      else if (a[1] === y) xs.push(a[0]);
    }
    if (xs.length < 2) return null;
    xs.sort(function (p, q) { return p - q; });
    return { x0: xs[0], x1: xs[xs.length - 1] };
  }

  /* The CONTIGUOUS run of metal at height y that contains x.
     spanAt reports the outermost crossings, which on a shape with a notch —
     the twin points of a talon, the split base of a wing — spans the gap as
     well as the metal. A banner placed on that span bridges the notch and
     hangs in mid-air over the leather, which is the single most glitch-looking
     thing a plate can do, so every band is placed on a real run instead. */
  function spanRun(poly, y, aroundX) {
    var xs = [], i, a, b;
    for (i = 0; i < poly.length; i++) {
      a = poly[i]; b = poly[(i + 1) % poly.length];
      /* the half-open rule: a vertex exactly on the scan line counts once, so
         the crossings always pair up into solid runs */
      if ((a[1] > y) !== (b[1] > y)) xs.push(a[0] + (b[0] - a[0]) * (y - a[1]) / (b[1] - a[1]));
    }
    if (xs.length < 2) return null;
    xs.sort(function (p, q) { return p - q; });
    var best = null, bestW = -1, k;
    for (k = 0; k + 1 < xs.length; k += 2) {
      var w = xs[k + 1] - xs[k];
      if (w <= 0.5) continue;
      var hit = aroundX !== undefined && aroundX >= xs[k] - 0.5 && aroundX <= xs[k + 1] + 0.5;
      if (hit) return { x0: xs[k], x1: xs[k + 1] };
      if (w > bestW) { bestW = w; best = { x0: xs[k], x1: xs[k + 1] }; }
    }
    return best;
  }

  /* ---------- small shape helpers ---------- */
  function roundRect(x0, y0, x1, y1, r) {
    r = Math.min(r, (x1 - x0) / 2, (y1 - y0) / 2);
    return P().M(x0 + r, y0).L(x1 - r, y0).Q(x1, y0, x1, y0 + r).L(x1, y1 - r).Q(x1, y1, x1 - r, y1)
      .L(x0 + r, y1).Q(x0, y1, x0, y1 - r).L(x0, y0 + r).Q(x0, y0, x0 + r, y0).Z();
  }
  function poly(pts) { var p = P().M(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) p.L(pts[i][0], pts[i][1]); return p.Z(); }
  function circlePath(cx, cy, r) {
    var k = r * 0.5523;
    return P().M(cx, cy - r).C(cx + k, cy - r, cx + r, cy - k, cx + r, cy).C(cx + r, cy + k, cx + k, cy + r, cx, cy + r)
      .C(cx - k, cy + r, cx - r, cy + k, cx - r, cy).C(cx - r, cy - k, cx - k, cy - r, cx, cy - r).Z();
  }
  function ellipsePath(cx, cy, rx, ry) { return circlePath(0, 0, 1).map(function (x, y) { return [cx + x * rx, cy + y * ry]; }); }
  function star(cx, cy, r, n, inner) {
    n = n || 5; inner = inner || 0.42; var pts = [];
    for (var i = 0; i < n * 2; i++) {
      var rr = i % 2 ? r * inner : r, a = (-90 + i * 180 / n) * Math.PI / 180;
      pts.push([cx + rr * Math.cos(a), cy + rr * Math.sin(a)]);
    }
    return poly(pts);
  }
  function ngon(cx, cy, r, n, rot) {
    var pts = [];
    for (var i = 0; i < n; i++) { var a = ((rot || 0) + i * 360 / n) * Math.PI / 180; pts.push([cx + r * Math.cos(a), cy + r * Math.sin(a)]); }
    return poly(pts);
  }
  function rot(path, cx, cy, a) {
    var ca = Math.cos(a), sa = Math.sin(a);
    return path.map(function (x, y) { var dx = x - cx, dy = y - cy; return [cx + dx * ca - dy * sa, cy + dx * sa + dy * ca]; });
  }

  /* =========================================================================
     CENTRE PLATE SILHOUETTES — all symmetric about (cx, cy), 12 originals
     b = { cx, cy, hw, hh }
     ========================================================================= */
  var CENTRES = {
    /* broad crown: three struck peaks over a hexagonal body, notched base */
    crownforge: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      var sx = b.hw * 0.60, py = t + b.hh * 0.30;
      return poly([
        [b.cx - sx, py], [b.cx - sx * 0.72, t + b.hh * 0.06], [b.cx - sx * 0.34, py - b.hh * 0.10],
        [b.cx, t], [b.cx + sx * 0.34, py - b.hh * 0.10], [b.cx + sx * 0.72, t + b.hh * 0.06],
        [b.cx + sx, py],
        [r, b.cy - b.hh * 0.10], [r, b.cy + b.hh * 0.40],
        [b.cx + b.hw * 0.62, m], [b.cx + b.hw * 0.30, m - b.hh * 0.10],
        [b.cx - b.hw * 0.30, m - b.hh * 0.10], [b.cx - b.hw * 0.62, m],
        [l, b.cy + b.hh * 0.40], [l, b.cy - b.hh * 0.10]
      ]);
    },
    /* pointed shield with squared shoulders */
    apexshield: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh, s = b.hw * 0.46;
      return P().M(b.cx - s, t).L(b.cx + s, t)
        .L(r, b.cy - b.hh * 0.42).L(r, b.cy + b.hh * 0.18)
        .Q(r, b.cy + b.hh * 0.70, b.cx + b.hw * 0.34, b.cy + b.hh * 0.86)
        .L(b.cx, m).L(b.cx - b.hw * 0.34, b.cy + b.hh * 0.86)
        .Q(l, b.cy + b.hh * 0.70, l, b.cy + b.hh * 0.18)
        .L(l, b.cy - b.hh * 0.42).Z();
    },
    /* scalloped oval with a beaded edge */
    regaloval: function (b) {
      var p = P(), n = 32;
      for (var i = 0; i <= n; i++) {
        var a = -Math.PI / 2 + i * 2 * Math.PI / n;
        var k = 1 - (i % 2 ? 0.045 : 0);
        var x = b.cx + b.hw * k * Math.cos(a), y = b.cy + b.hh * k * Math.sin(a);
        if (i === 0) p.M(x, y); else p.L(x, y);
      }
      return p.Z();
    },
    /* the clean flat-topped hexagon — the classic world-title slab */
    titanhex: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      var s = b.hw * 0.40, c = b.hw * 0.10;
      return poly([
        [b.cx - s, t], [b.cx + s, t],
        [r - c, b.cy - b.hh * 0.22], [r, b.cy - b.hh * 0.06], [r, b.cy + b.hh * 0.06], [r - c, b.cy + b.hh * 0.22],
        [b.cx + s, m], [b.cx - s, m],
        [l + c, b.cy + b.hh * 0.22], [l, b.cy + b.hh * 0.06], [l, b.cy - b.hh * 0.06], [l + c, b.cy - b.hh * 0.22]
      ]);
    },
    /* swept wings either side of a tapered body */
    vanguardwing: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      return poly([
        [b.cx, t], [b.cx + b.hw * 0.30, t + b.hh * 0.14], [b.cx + b.hw * 0.52, b.cy - b.hh * 0.56],
        [b.cx + b.hw * 0.80, t + b.hh * 0.26], [r, b.cy - b.hh * 0.34], [b.cx + b.hw * 0.86, b.cy + b.hh * 0.02],
        [b.cx + b.hw * 0.58, b.cy + b.hh * 0.26], [b.cx + b.hw * 0.42, b.cy + b.hh * 0.74], [b.cx, m],
        [b.cx - b.hw * 0.42, b.cy + b.hh * 0.74], [b.cx - b.hw * 0.58, b.cy + b.hh * 0.26],
        [b.cx - b.hw * 0.86, b.cy + b.hh * 0.02], [l, b.cy - b.hh * 0.34], [b.cx - b.hw * 0.80, t + b.hh * 0.26],
        [b.cx - b.hw * 0.52, b.cy - b.hh * 0.56], [b.cx - b.hw * 0.30, t + b.hh * 0.14]
      ]);
    },
    /* gothic arch crown on a squared, footed base */
    sovereignarch: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      return P().M(l, m - b.hh * 0.12).L(l, b.cy - b.hh * 0.12)
        .Q(l, t + b.hh * 0.04, b.cx, t).Q(r, t + b.hh * 0.04, r, b.cy - b.hh * 0.12)
        .L(r, m - b.hh * 0.12).L(r - b.hw * 0.12, m - b.hh * 0.12).L(r - b.hw * 0.12, m)
        .L(l + b.hw * 0.12, m).L(l + b.hw * 0.12, m - b.hh * 0.12).Z();
    },
    /* cut-corner slab — the widest engraving face in the range */
    ironcladblock: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      var cx2 = b.hw * 0.26, cy2 = b.hh * 0.26;
      return poly([[l + cx2, t], [r - cx2, t], [r, t + cy2], [r, m - cy2], [r - cx2, m], [l + cx2, m], [l, m - cy2], [l, t + cy2]]);
    },
    /* rayed disc with a serrated star edge */
    starcrest: function (b) {
      var p = P(), n = 20;
      for (var i = 0; i < n * 2; i++) {
        var rr = i % 2 ? 0.84 : 1, a = (-90 + i * 180 / n) * Math.PI / 180;
        var x = b.cx + b.hw * rr * Math.cos(a), y = b.cy + b.hh * rr * Math.sin(a);
        if (i === 0) p.M(x, y); else p.L(x, y);
      }
      return p.Z();
    },
    /* scrolled ornamental flanks under a domed crown */
    monarchscroll: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      return P().M(b.cx, t)
        .Q(b.cx + b.hw * 0.56, t + b.hh * 0.03, b.cx + b.hw * 0.66, b.cy - b.hh * 0.50)
        .C(r, b.cy - b.hh * 0.40, r, b.cy - b.hh * 0.02, b.cx + b.hw * 0.76, b.cy + b.hh * 0.04)
        .C(r, b.cy + b.hh * 0.20, b.cx + b.hw * 0.74, b.cy + b.hh * 0.56, b.cx + b.hw * 0.48, b.cy + b.hh * 0.64)
        .Q(b.cx + b.hw * 0.24, m, b.cx, m)
        .Q(b.cx - b.hw * 0.24, m, b.cx - b.hw * 0.48, b.cy + b.hh * 0.64)
        .C(b.cx - b.hw * 0.74, b.cy + b.hh * 0.56, l, b.cy + b.hh * 0.20, b.cx - b.hw * 0.76, b.cy + b.hh * 0.04)
        .C(l, b.cy - b.hh * 0.02, l, b.cy - b.hh * 0.40, b.cx - b.hw * 0.66, b.cy - b.hh * 0.50)
        .Q(b.cx - b.hw * 0.56, t + b.hh * 0.03, b.cx, t).Z();
    },
    /* truncated diamond with long angled shoulders */
    vertexdiamond: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh, s = b.hw * 0.26;
      return poly([[b.cx - s, t], [b.cx + s, t], [b.cx + b.hw * 0.74, b.cy - b.hh * 0.40],
      [r, b.cy], [b.cx + b.hw * 0.74, b.cy + b.hh * 0.40], [b.cx + s, m], [b.cx - s, m],
      [b.cx - b.hw * 0.74, b.cy + b.hh * 0.40], [l, b.cy], [b.cx - b.hw * 0.74, b.cy - b.hh * 0.40]]);
    },
    /* full round plate — the biggest single medallion face */
    colosseumround: function (b) { return ellipsePath(b.cx, b.cy, b.hw, b.hh); },
    /* aggressive talon silhouette with twin lower points */
    phantomtalon: function (b) {
      var l = b.cx - b.hw, r = b.cx + b.hw, t = b.cy - b.hh, m = b.cy + b.hh;
      return poly([
        [b.cx, t], [b.cx + b.hw * 0.46, t + b.hh * 0.10], [b.cx + b.hw * 0.92, b.cy - b.hh * 0.46],
        [r, b.cy - b.hh * 0.06], [b.cx + b.hw * 0.80, b.cy + b.hh * 0.34],
        [b.cx + b.hw * 0.94, m], [b.cx + b.hw * 0.40, b.cy + b.hh * 0.66],
        [b.cx, m], [b.cx - b.hw * 0.40, b.cy + b.hh * 0.66],
        [b.cx - b.hw * 0.94, m], [b.cx - b.hw * 0.80, b.cy + b.hh * 0.34],
        [l, b.cy - b.hh * 0.06], [b.cx - b.hw * 0.92, b.cy - b.hh * 0.46], [b.cx - b.hw * 0.46, t + b.hh * 0.10]
      ]);
    }
  };

  /* ---------- side / outer plate families ---------- */
  var SIDES = {
    shieldlet: function (cx, cy, hw, hh) { return P().M(cx - hw, cy - hh).L(cx + hw, cy - hh).L(cx + hw, cy + hh * 0.22).Q(cx + hw, cy + hh * 0.78, cx, cy + hh).Q(cx - hw, cy + hh * 0.78, cx - hw, cy + hh * 0.22).Z(); },
    rounded: function (cx, cy, hw, hh) { return roundRect(cx - hw, cy - hh, cx + hw, cy + hh, Math.min(hw, hh) * 0.26); },
    hexlet: function (cx, cy, hw, hh) { return poly([[cx - hw * 0.44, cy - hh], [cx + hw * 0.44, cy - hh], [cx + hw, cy - hh * 0.12], [cx + hw, cy + hh * 0.12], [cx + hw * 0.44, cy + hh], [cx - hw * 0.44, cy + hh], [cx - hw, cy + hh * 0.12], [cx - hw, cy - hh * 0.12]]); },
    ovallet: function (cx, cy, hw, hh) { return ellipsePath(cx, cy, hw, hh); },
    /* the reference's clipped-corner plate */
    angular: function (cx, cy, hw, hh) { var c = Math.min(hw, hh) * 0.26; return poly([[cx - hw + c, cy - hh], [cx + hw - c, cy - hh], [cx + hw, cy - hh + c], [cx + hw, cy + hh - c], [cx + hw - c, cy + hh], [cx - hw + c, cy + hh], [cx - hw, cy + hh - c], [cx - hw, cy - hh + c]]); },
    talonlet: function (cx, cy, hw, hh) { return poly([[cx, cy - hh], [cx + hw * 0.86, cy - hh * 0.54], [cx + hw, cy + hh * 0.04], [cx + hw * 0.70, cy + hh], [cx, cy + hh * 0.62], [cx - hw * 0.70, cy + hh], [cx - hw, cy + hh * 0.04], [cx - hw * 0.86, cy - hh * 0.54]]); },
    crownlet: function (cx, cy, hw, hh) { return poly([[cx - hw, cy + hh * 0.56], [cx - hw, cy - hh * 0.40], [cx - hw * 0.62, cy - hh], [cx - hw * 0.30, cy - hh * 0.52], [cx, cy - hh * 1.02], [cx + hw * 0.30, cy - hh * 0.52], [cx + hw * 0.62, cy - hh], [cx + hw, cy - hh * 0.40], [cx + hw, cy + hh * 0.56], [cx + hw * 0.52, cy + hh], [cx - hw * 0.52, cy + hh]]); },
    scallop: function (cx, cy, hw, hh) {
      var p = P(), n = 18;
      for (var i = 0; i <= n; i++) {
        var a = -Math.PI / 2 + i * 2 * Math.PI / n, k = 1 - (i % 2 ? 0.11 : 0);
        var x = cx + hw * k * Math.cos(a), y = cy + hh * k * Math.sin(a);
        if (i === 0) p.M(x, y); else p.L(x, y);
      }
      return p.Z();
    }
  };

  /* ---------- banner styles ---------- */
  var BANNERS = {
    ribbon: function (s) {
      if (s.arc) return P().M(s.x0, s.y).Q(s.cx, s.y - s.bow, s.x1, s.y).L(s.x1 - 8, s.y + s.h).Q(s.cx, s.y - s.bow + s.h, s.x0 + 8, s.y + s.h).Z();
      return roundRect(s.x0, s.y, s.x1, s.y + s.h, Math.min(6, s.h * 0.2));
    },
    chevron: function (s) {
      var n = Math.min(16, s.h * 0.5);
      return poly([[s.x0, s.y], [s.x1, s.y], [s.x1 - n, s.y + s.h / 2], [s.x1, s.y + s.h], [s.x0, s.y + s.h], [s.x0 + n, s.y + s.h / 2]]);
    },
    arch: function (s) {
      var bow = s.arc ? Math.abs(s.bow) : Math.max(12, s.h * 0.6);
      return P().M(s.x0, s.y + s.h).Q(s.cx, s.y - bow + s.h, s.x1, s.y + s.h).Q(s.cx, s.y - bow, s.x0, s.y + s.h).Z();
    },
    bar: function (s) { return roundRect(s.x0 + 6, s.y + 1, s.x1 - 6, s.y + s.h - 1, 2); },
    plaque: function (s) { var c = Math.min(10, s.h * 0.3); return poly([[s.x0 + c, s.y], [s.x1 - c, s.y], [s.x1, s.y + c], [s.x1, s.y + s.h - c], [s.x1 - c, s.y + s.h], [s.x0 + c, s.y + s.h], [s.x0, s.y + s.h - c], [s.x0, s.y + c]]); },
    scroll: function (s) {
      var t = Math.min(20, (s.x1 - s.x0) * 0.08);
      return P().M(s.x0 + t, s.y).L(s.x1 - t, s.y).Q(s.x1, s.y, s.x1, s.y + s.h / 2).Q(s.x1, s.y + s.h, s.x1 - t, s.y + s.h)
        .L(s.x0 + t, s.y + s.h).Q(s.x0, s.y + s.h, s.x0, s.y + s.h / 2).Q(s.x0, s.y, s.x0 + t, s.y).Z();
    },
    split: function (s) {
      var t = Math.min(22, (s.x1 - s.x0) * 0.09);
      return poly([[s.x0 - t, s.y - 3], [s.x0 + 5, s.y], [s.x1 - 5, s.y], [s.x1 + t, s.y - 3], [s.x1 + t, s.y + s.h + 3],
      [s.x1 - 5, s.y + s.h], [s.x0 + 5, s.y + s.h], [s.x0 - t, s.y + s.h + 3]]);
    },
    none: function () { return null; }
  };
  var BANNER_HAS_FILL = { ribbon: 1, chevron: 1, arch: 1, bar: 1, plaque: 1, scroll: 1, split: 1, none: 0 };

  /* =========================================================================
     TEMPLATE REGISTRY — hw/hh are the centre plate half-size about (CX, CY)
     yoke: how the leather backing behind the centre plate is shaped
     ========================================================================= */
  var TEMPLATES = [
    { id: 'crownforge', name: 'CrownForge', desc: 'Broad crown-contoured plate with sculpted flanks.', side: 'crownlet', outer: 'crownlet', yoke: 'hex', arc: true, hw: 188, hh: 186 },
    { id: 'apexshield', name: 'Apex Shield', desc: 'Sharp shield and peak, geometric side plates.', side: 'shieldlet', outer: 'angular', yoke: 'hex', arc: false, hw: 184, hh: 190 },
    { id: 'regaloval', name: 'Regal Oval', desc: 'Tall scalloped oval with a beaded edge.', side: 'ovallet', outer: 'scallop', yoke: 'arch', arc: true, hw: 176, hh: 184 },
    { id: 'titanhex', name: 'Titan Hex', desc: 'Flat-topped hexagon slab, heavy and modern.', side: 'hexlet', outer: 'hexlet', yoke: 'hex', arc: false, hw: 190, hh: 182 },
    { id: 'vanguardwing', name: 'Vanguard Wing', desc: 'Swept wings either side of a tapered body.', side: 'angular', outer: 'angular', yoke: 'wing', arc: true, hw: 198, hh: 178 },
    { id: 'sovereignarch', name: 'Sovereign Arch', desc: 'Gothic arch crown with a squared, footed base.', side: 'rounded', outer: 'rounded', yoke: 'arch', arc: true, hw: 178, hh: 188 },
    { id: 'ironcladblock', name: 'Ironclad Block', desc: 'Cut-corner slab — the widest engraving area.', side: 'angular', outer: 'rounded', yoke: 'hex', arc: false, hw: 194, hh: 176 },
    { id: 'starcrest', name: 'Starcrest', desc: 'Rayed disc with a serrated star edge.', side: 'ovallet', outer: 'hexlet', yoke: 'round', arc: true, hw: 180, hh: 182 },
    { id: 'monarchscroll', name: 'Monarch Scroll', desc: 'Scrolled ornamental flanks and a domed crown.', side: 'crownlet', outer: 'ovallet', yoke: 'arch', arc: true, hw: 186, hh: 184 },
    { id: 'vertexdiamond', name: 'Vertex Diamond', desc: 'Truncated diamond with long angled shoulders.', side: 'hexlet', outer: 'angular', yoke: 'wing', arc: false, hw: 196, hh: 178 },
    { id: 'colosseumround', name: 'Colosseum Round', desc: 'Full round plate — the biggest medallion face.', side: 'ovallet', outer: 'rounded', yoke: 'round', arc: true, hw: 180, hh: 180 },
    { id: 'phantomtalon', name: 'Phantom Talon', desc: 'Aggressive talon silhouette with twin lower points.', side: 'talonlet', outer: 'talonlet', yoke: 'shield', arc: false, hw: 192, hh: 188 }
  ];

  /* =========================================================================
     THE LEATHER — one seamless silhouette.
     Two straight arms meet the centre yoke exactly where the yoke's shoulder
     crosses the band edge, so the union is a single closed outline with no
     overlap and no seam.
     ========================================================================= */
  function yokeProfile(style, YW, YH) {
    /* returns { shoulder: fn(dy)->halfWidth for |dy| in [0, YH], crownTop: [pts] } */
    var sh = style === 'wing' ? 0.62 : style === 'shield' ? 0.50 : 0.55;   // fraction of YW consumed by the shoulder run
    return { sh: sh, crown: 1 - sh };
  }
  /* the full outer outline of the leather, parameterised so the stitch line is the same shape */
  function strapOutline(t, inset) {
    inset = inset || 0;
    var bh = BH - inset, x0 = X0 + inset, x1 = X1 - inset;
    /* fixed yoke: the modelled belt body (Blender/Higgsfield GLB) uses these exact
       numbers, so the vector fallback and the 3D asset share one silhouette */
    var YW = YOKE_W - inset, YH = YOKE_H - inset;
    var pr = yokeProfile(t.yoke, YW, YH);
    var sh = pr.sh, crown = pr.crown;                      // crown half-width fraction
    /* the shoulder line runs from (CX-YW, CY) to (CX-YW*crown, CY-YH). It crosses y = CY-bh at: */
    var tt = bh / YH;
    var jx = CX - YW + tt * (YW * sh);                     // left joint x
    var jx2 = 2 * CX - jx;
    var cw = YW * crown;                                   // crown half-width
    var R = Math.max(6, ENDR - inset * 0.6);
    var p = P();
    var sy = t.yoke === 'shield' ? YH * 0.16 : 0;          // pointed crown gets a small peak run

    p.M(x0, CY - bh + R).Q(x0, CY - bh, x0 + R, CY - bh).L(jx - 10, CY - bh);
    p.Q(jx + 6, CY - bh, jx + 16, CY - bh - 17);           // rounded knuckle into the shoulder
    if (t.yoke === 'round') {
      p.C(CX - YW * 0.86, CY - YH * 0.62, CX - cw * 1.10, CY - YH, CX - cw * 0.40, CY - YH);
      p.L(CX + cw * 0.40, CY - YH);
      p.C(CX + cw * 1.10, CY - YH, CX + YW * 0.86, CY - YH * 0.62, jx2 - 16, CY - bh - 17);
    } else if (t.yoke === 'arch') {
      p.L(CX - cw * 0.98, CY - YH * 0.80);
      p.Q(CX - cw * 0.52, CY - YH, CX, CY - YH);
      p.Q(CX + cw * 0.52, CY - YH, CX + cw * 0.98, CY - YH * 0.80);
      p.L(jx2 - 16, CY - bh - 17);
    } else if (t.yoke === 'shield') {
      p.L(CX - cw, CY - YH + sy);
      p.L(CX - cw * 0.36, CY - YH); p.L(CX + cw * 0.36, CY - YH);
      p.L(CX + cw, CY - YH + sy);
      p.L(jx2 - 16, CY - bh - 17);
    } else if (t.yoke === 'wing') {
      p.L(CX - cw * 1.02, CY - YH * 0.66);
      p.Q(CX - cw * 0.74, CY - YH, CX - cw * 0.30, CY - YH * 0.90);
      p.Q(CX, CY - YH * 1.04, CX + cw * 0.30, CY - YH * 0.90);
      p.Q(CX + cw * 0.74, CY - YH, CX + cw * 1.02, CY - YH * 0.66);
      p.L(jx2 - 16, CY - bh - 17);
    } else {                                                /* hex */
      p.L(CX - cw, CY - YH); p.L(CX + cw, CY - YH);
      p.L(jx2 - 16, CY - bh - 17);
    }
    p.Q(jx2 - 6, CY - bh, jx2 + 10, CY - bh).L(x1 - R, CY - bh).Q(x1, CY - bh, x1, CY - bh + R);
    p.L(x1, CY + bh - R).Q(x1, CY + bh, x1 - R, CY + bh).L(jx2 + 8, CY + bh);
    p.Q(jx2 - 6, CY + bh, jx2 - 16, CY + bh + 17);
    if (t.yoke === 'round') {
      p.C(CX + YW * 0.86, CY + YH * 0.62, CX + cw * 1.10, CY + YH, CX + cw * 0.40, CY + YH);
      p.L(CX - cw * 0.40, CY + YH);
      p.C(CX - cw * 1.10, CY + YH, CX - YW * 0.86, CY + YH * 0.62, jx + 16, CY + bh + 17);
    } else if (t.yoke === 'arch') {
      p.L(CX + cw * 0.98, CY + YH * 0.80);
      p.Q(CX + cw * 0.52, CY + YH, CX, CY + YH);
      p.Q(CX - cw * 0.52, CY + YH, CX - cw * 0.98, CY + YH * 0.80);
      p.L(jx + 16, CY + bh + 17);
    } else if (t.yoke === 'shield') {
      p.L(CX + cw, CY + YH - sy);
      p.L(CX + cw * 0.36, CY + YH); p.L(CX - cw * 0.36, CY + YH);
      p.L(CX - cw, CY + YH - sy);
      p.L(jx + 16, CY + bh + 17);
    } else if (t.yoke === 'wing') {
      p.L(CX + cw * 1.02, CY + YH * 0.66);
      p.Q(CX + cw * 0.74, CY + YH, CX + cw * 0.30, CY + YH * 0.90);
      p.Q(CX, CY + YH * 1.04, CX - cw * 0.30, CY + YH * 0.90);
      p.Q(CX - cw * 0.74, CY + YH, CX - cw * 1.02, CY + YH * 0.66);
      p.L(jx + 16, CY + bh + 17);
    } else {
      p.L(CX + cw, CY + YH); p.L(CX - cw, CY + YH);
      p.L(jx + 16, CY + bh + 17);
    }
    p.Q(jx + 6, CY + bh, jx - 10, CY + bh).L(x0 + R, CY + bh).Q(x0, CY + bh, x0, CY + bh - R).Z();
    return p;
  }


  /* =========================================================================
     THE HIDE, CUT TO THE PLATES
     A real belt is not a strap with plates dropped on top of it: the hide is
     cut to the plate, so the leather showing around a round plate is a round
     border and the leather around a shield is a shield-shaped border. Here the
     silhouette is therefore DERIVED from the plate outlines rather than chosen
     from a fixed list of yoke shapes — the outline is the plate swept by a
     disc of radius `m`, unioned with the plain band of the two arms. That
     gives a border of exactly constant width all the way round whatever shape
     the customer picked, and it makes it impossible for a plate to overhang
     the leather, because the leather is defined as the plate plus a margin.
     ========================================================================= */
  var HIDE_M = 34;        // width of the hide border around the centre plate
  var HIDE_MS = 9;        // clearance kept around each side plate
  var HIDE_STEP = 3;      // sampling pitch in belt units

  /* upper (sign -1) or lower (sign +1) boundary of poly (+) disc(m), folded
     into the running profile `arr` sampled at the ascending x values `xs` */
  function envelope(poly, m, xs, arr, sign) {
    if (!poly || poly.length < 3 || m <= 0) return;
    var pts = poly.slice().sort(function (a, b) { return a[0] - b[0]; });
    var lo = 0, hi = 0, m2 = m * m, k, i;
    for (k = 0; k < xs.length; k++) {
      var x = xs[k];
      while (lo < pts.length && pts[lo][0] < x - m) lo++;
      while (hi < pts.length && pts[hi][0] <= x + m) hi++;
      var best = arr[k];
      for (i = lo; i < hi; i++) {
        var dx = pts[i][0] - x;
        var y = pts[i][1] + sign * Math.sqrt(m2 - dx * dx);
        if (sign < 0 ? y < best : y > best) best = y;
      }
      arr[k] = best;
    }
  }
  /* a light rolling average: leather cannot hold a razor-sharp inside corner,
     so the joint where the yoke meets the arms is eased rather than creased */
  function easeProfile(arr, w) {
    var out = arr.slice(), i, j, n = arr.length, half = (w - 1) / 2;
    for (i = 0; i < n; i++) {
      var sum = 0, cnt = 0;
      for (j = i - half; j <= i + half; j++) { if (j < 0 || j >= n) continue; sum += arr[j]; cnt++; }
      out[i] = sum / cnt;
    }
    return out;
  }
  /* Ramer-Douglas-Peucker on a y = f(x) profile: the straight arms collapse to
     two points and every unit of detail is spent on the cut around the plate */
  function simplify(xs, ys, eps) {
    var n = xs.length, keep = new Array(n), st = [[0, n - 1]], i;
    for (i = 0; i < n; i++) keep[i] = false;
    keep[0] = keep[n - 1] = true;
    while (st.length) {
      var seg = st.pop(), a = seg[0], b = seg[1];
      if (b <= a + 1) continue;
      var x0 = xs[a], y0 = ys[a], dx = xs[b] - x0, dy = ys[b] - y0;
      var len = Math.sqrt(dx * dx + dy * dy) || 1, worst = -1, wi = -1;
      for (i = a + 1; i < b; i++) {
        var d = Math.abs(dy * (xs[i] - x0) - dx * (ys[i] - y0)) / len;
        if (d > worst) { worst = d; wi = i; }
      }
      if (worst > eps) { keep[wi] = true; st.push([a, wi]); st.push([wi, b]); }
    }
    var ox = [], oy = [];
    for (i = 0; i < n; i++) if (keep[i]) { ox.push(xs[i]); oy.push(ys[i]); }
    return [ox, oy];
  }

  /* obstacles: [{poly: [[x,y]...], m: margin}] — the plate outlines the hide
     has to be cut around. `inset` walks the whole silhouette inwards, which is
     how the two stitch runs stay exactly parallel to the edge. */
  function hideOutline(obst, inset) {
    inset = inset || 0;
    var bh = BH - inset, x0 = X0 + inset, x1 = X1 - inset;
    var R = Math.max(6, ENDR - inset * 0.6);
    var xs = [], top = [], bot = [], x, i;
    for (x = x0; x < x1; x += HIDE_STEP) xs.push(x);
    xs.push(x1);
    for (i = 0; i < xs.length; i++) { top.push(CY - bh); bot.push(CY + bh); }
    for (i = 0; i < obst.length; i++) {
      var m = obst[i].m - inset;
      if (m < 1.5) m = 1.5;
      envelope(obst[i].poly, m, xs, top, -1);
      envelope(obst[i].poly, m, xs, bot, 1);
    }
    top = easeProfile(top, 5); bot = easeProfile(bot, 5);
    /* the rounded ends of the two tails are drawn as real arcs, so the profile
       itself only has to cover the run between them */
    var ta = simplify(xs, top, 0.45), ba = simplify(xs, bot, 0.45);
    var p = P();
    p.M(x0, CY - bh + R).Q(x0, CY - bh, x0 + R, CY - bh);
    for (i = 0; i < ta[0].length; i++) if (ta[0][i] > x0 + R && ta[0][i] < x1 - R) p.L(ta[0][i], ta[1][i]);
    p.L(x1 - R, CY - bh).Q(x1, CY - bh, x1, CY - bh + R);
    p.L(x1, CY + bh - R).Q(x1, CY + bh, x1 - R, CY + bh);
    for (i = ba[0].length - 1; i >= 0; i--) if (ba[0][i] > x0 + R && ba[0][i] < x1 - R) p.L(ba[0][i], ba[1][i]);
    p.L(x0 + R, CY + bh).Q(x0, CY + bh, x0, CY + bh - R).Z();
    return p;
  }

  function strapGeom(t, obst) {
    obst = obst || [];
    var band = hideOutline(obst, 0);
    var stitch = hideOutline(obst, 15);
    var stitch2 = hideOutline(obst, 24);
    /* hardware: 4 x 2 eyelets on the left tail, 4 x 2 snap studs on the right tail,
       plus the gold end tip. Positions are fixed so nothing can collide with a plate. */
    var eyelets = [], snaps = [];
    for (var i = 0; i < 4; i++) {
      for (var r = -1; r <= 1; r += 2) {
        eyelets.push({ x: 250 - i * 44, y: CY + r * 30, r: 12 });
        snaps.push({ x: 1350 + i * 44, y: CY + r * 30, r: 13 });
      }
    }
    var tipX = 1496, tipR = 16;
    var tip = P().M(tipX, CY - BH + 2).L(X1 - tipR, CY - BH + 2).Q(X1 - 2, CY - BH + 2, X1 - 2, CY - BH + 2 + tipR)
      .L(X1 - 2, CY + BH - 2 - tipR).Q(X1 - 2, CY + BH - 2, X1 - tipR, CY + BH - 2)
      .L(tipX, CY + BH - 2).L(tipX + 14, CY + BH - 26).L(tipX + 14, CY - BH + 26).Z();
    var keeper = roundRect(1290, CY - BH + 6, 1318, CY + BH - 6, 8);
    return {
      band: band, stitch: stitch, stitch2: stitch2, tip: tip, keeper: keeper,
      eyelets: eyelets, snaps: snaps, bh: BH, x0: X0, x1: X1, cy: CY
    };
  }

  /* =========================================================================
     PLATE STACK — tier outlines, and zone placement derived from the tier.
     Tier 0 is the full plate; each further tier is a true inset (not a scale),
     so the annulus between tier 0 and tier 1 is always wide enough to carry
     the outer banners while the ornament sits on the top tier.
     ========================================================================= */
  var FIELD_INSET = 24, SIDE_FIELD_INSET = 9;
  var TIER_INSET = [0, 46, 66, 84];          // cumulative inset in belt units
  var SIDE_TIER_INSET = [0, 16, 24, 30];

  /* signed area of a polyline (positive = counter-clockwise in a y-down space) */
  function areaOf(pts) {
    var a = 0, n = pts.length, i;
    for (i = 0; i < n; i++) { var p = pts[i], q = pts[(i + 1) % n]; a += p[0] * q[1] - q[0] * p[1]; }
    return a / 2;
  }
  /* a TRUE inward offset: every vertex moves along its angle bisector by the same
     distance, so the metal frame is the same width the whole way round a plate —
     a proportional scale makes it thin at the points and fat at the flats. */
  function offsetPath(path, d) {
    var raw = flatten(path, 5), pts = [], i;
    for (i = 0; i < raw.length; i++) {
      var q = raw[i];
      if (!pts.length || Math.hypot(q[0] - pts[pts.length - 1][0], q[1] - pts[pts.length - 1][1]) > 0.6) pts.push(q);
    }
    var n = pts.length;
    if (n > 3 && Math.hypot(pts[0][0] - pts[n - 1][0], pts[0][1] - pts[n - 1][1]) < 0.6) { pts.pop(); n--; }
    if (n < 4) return null;
    var sgn = areaOf(pts) > 0 ? 1 : -1;
    var out = [];
    for (i = 0; i < n; i++) {
      var a = pts[(i - 1 + n) % n], c = pts[i], b = pts[(i + 1) % n];
      var v1x = c[0] - a[0], v1y = c[1] - a[1], l1 = Math.hypot(v1x, v1y) || 1; v1x /= l1; v1y /= l1;
      var v2x = b[0] - c[0], v2y = b[1] - c[1], l2 = Math.hypot(v2x, v2y) || 1; v2x /= l2; v2y /= l2;
      var nx = v1y + v2y, ny = -(v1x + v2x), ln = Math.hypot(nx, ny);
      if (ln < 1e-6) continue;
      nx /= ln; ny /= ln;
      var cosv = v1x * v2x + v1y * v2y;
      var mit = 1 / Math.max(0.42, Math.sqrt(Math.max(0.02, (1 + cosv) / 2)));
      if (mit > 2.0) mit = 2.0;
      out.push([c[0] + sgn * nx * d * mit, c[1] + sgn * ny * d * mit]);
    }
    if (out.length < 4) return null;
    /* reject a collapsed or inverted result */
    var a0 = Math.abs(areaOf(pts)), a1 = Math.abs(areaOf(out));
    if (!(a1 > a0 * 0.06) || a1 > a0) return null;
    return poly(out);
  }
  function insetPath(path, box, ins) {
    if (!ins) return path;
    var off = offsetPath(path, ins);
    if (off) return off;
    var kx = Math.max(0.2, 1 - ins / (box.w / 2)), ky = Math.max(0.2, 1 - ins / (box.h / 2));
    return path.scale(box.cx, box.cy, kx, ky);
  }
  function layerOutlines(plate, n) {
    var tbl = plate.side ? SIDE_TIER_INSET : TIER_INSET, out = [];
    for (var i = 0; i < n; i++) out.push(insetPath(plate.path, plate.box, tbl[Math.min(i, tbl.length - 1)]));
    return out;
  }
  /* the surface the ornament + inner text live on */
  function topTier(plate, n) {
    var tbl = plate.side ? SIDE_TIER_INSET : TIER_INSET;
    var ins = tbl[Math.min(Math.max(1, n) - 1, tbl.length - 1)];
    /* a single-layer plate still reserves a virtual first step so the outer banners
       have somewhere to sit that is clear of the ornament */
    if (n <= 1) ins = 0;
    var p = insetPath(plate.path, plate.box, ins);
    return { path: p, box: p.bbox(), inset: ins };
  }

  /* widest span anywhere on the shape */
  function maxSpan(poly, cy, hh) {
    var best = 0, k, s;
    for (k = -24; k <= 24; k++) { s = spanAt(poly, cy + hh * k / 25); if (s) best = Math.max(best, s.x1 - s.x0); }
    return best;
  }
  /* true bbox from the flattened outline (curve control points overstate the real extent) */
  function trueBox(poly) {
    var a = [1e9, 1e9, -1e9, -1e9];
    poly.forEach(function (p) { a[0] = Math.min(a[0], p[0]); a[1] = Math.min(a[1], p[1]); a[2] = Math.max(a[2], p[0]); a[3] = Math.max(a[3], p[1]); });
    return { x: a[0], y: a[1], w: a[2] - a[0], h: a[3] - a[1], cx: (a[0] + a[2]) / 2, cy: (a[1] + a[3]) / 2 };
  }
  /* walk inward from the plate edge until a band of height h sits on metal that is
     at least minFrac of the plate's widest run — keeps every banner on a broad face */
  function fitBand(poly, cy, dir, lo, hi, h, minFrac, wide, cx) {
    var d, k, y, sp, ok, narrow;
    for (d = hi; d >= lo; d -= 1.5) {
      ok = true; narrow = 1e9;
      for (k = 0; k <= 4; k++) {
        y = cy + dir * (d - h / 2 + h * k / 4);
        sp = spanRun(poly, y, cx);
        if (!sp) { ok = false; break; }
        narrow = Math.min(narrow, sp.x1 - sp.x0);
      }
      if (ok && narrow >= minFrac * wide) return d;
    }
    return lo;
  }

  /* ---------- zone (text slot) placement ----------
     y and h are absolute belt units; the slot is clamped to the narrowest
     horizontal run of the plate across its whole height, so a banner can
     never poke outside the metal. */
  function mkSlot(id, plateKey, poly, cy, y, h, arc, bow, pad, cx, minW) {
    var sp = spanRun(poly, cy + y, cx);
    if (!sp) return null;
    y = cy + y;
    /* clamp using the narrowest CONTIGUOUS run across the slot's whole height,
       including the crown and the trough of the arc if the banner is bowed, so
       the finished shape sits wholly on metal */
    /* Every nameplate style adds something beyond the bare box it is given —
       a bowed ribbon rises above it, an arch domes over it, a split banner
       flares its tails out past both ends. The slot is therefore measured
       against the biggest envelope any style can draw in it, so whichever one
       the customer picks still lands wholly on the metal. */
    var bw = Math.abs(bow || 0);
    /* an arch domes upward whatever the bow, a bowed ribbon rises or falls with
       it, and a split banner's tails clear the box by about three units */
    var up = Math.max(bow > 0 ? bw : 0, h * 0.30) + 3;
    var dn = Math.max(bow < 0 ? bw : 0, 3) + 3;
    var top = y - h / 2 - up, bot = y + h / 2 + dn;
    /* lo is the innermost left edge and hi the innermost right edge across the
       samples, so they start at the far side of the plate, not at infinity —
       the original pair was initialised the wrong way round, which silently
       disabled this clamp and is why bands could hang off a plate at all */
    var lo = -1e9, hi = 1e9, k, yy, s2, hits = 0;
    for (k = 0; k <= 8; k++) {
      yy = top + (bot - top) * k / 8;
      s2 = spanRun(poly, yy, cx);
      if (s2) { lo = Math.max(lo, s2.x0); hi = Math.min(hi, s2.x1); hits++; }
    }
    /* a sample that found no metal at all means the band would overhang the
       plate top or bottom — there is no honest way to place it there */
    if (hits < 9) return null;
    /* the runs at different heights do not overlap: there is no straight band
       that lies on metal all the way across here */
    if (lo > hi) return null;
    pad = pad === undefined ? 16 : pad;
    /* the widest tail any style flares past the ends, plus a hair */
    pad = Math.max(pad, Math.min(22, (hi - lo) * 0.09) + 4);
    var x0 = lo + pad, x1 = hi - pad;
    if (x1 - x0 < (minW || 48)) return null;
    return { id: id, plate: plateKey, x0: x0, x1: x1, cx: (x0 + x1) / 2, y: y - h / 2, h: h, arc: !!arc, bow: bow || 0 };
  }

  /* Walk a band inwards from the rim until it genuinely fits on the metal,
     then, only if nothing fits at all, try again a little shorter. Searching
     beats computing a single position: a plate outline can narrow, notch or
     step anywhere, and the only honest test is whether the band lands on it. */
  /* Walk the whole allowed band and keep the WIDEST seat, not the first one
     that happens to fit. Taking the first fit parked side-plate nameplates
     near the narrow point of the plate, so a five-letter word had about 14
     units of run on a plate 120 units wide and came out an unreadable smear.
     Every candidate is still validated by mkSlot, so this only ever moves a
     banner to a roomier spot inside the same surface. Centre plates keep the
     first-fit walk: their four zones are stacked in lanes, and letting zone 1
     wander to the plate's widest point eats the room zone 2 needs. */
  function placeSlot(id, key, poly, cy, dir, lo, hi, h, arc, bow, pad, cx, minW, widest) {
    var shrink = [1, 0.84, 0.7], i, d, sl, best, bestW;
    for (i = 0; i < shrink.length; i++) {
      var hh = h * shrink[i], bb = bow * shrink[i];
      best = null; bestW = -1;
      for (d = hi; d >= lo - 0.01; d -= 2) {
        sl = mkSlot(id, key, poly, cy, dir * d, hh, arc, bb, pad, cx, minW);
        if (!sl) continue;
        if (!widest) return sl;
        if (sl.x1 - sl.x0 > bestW) { bestW = sl.x1 - sl.x0; best = sl; }
      }
      if (best) return best;
    }
    return null;
  }

  /* ---------- build a full belt ---------- */
  /* ------------------------------------------------------------------
     Nothing metal is ever allowed to cross the leather. Real belts show a
     constant band of hide around every plate; when a plate outline is bigger
     than the yoke it sits on, the plate reads as if it has been cut through
     the strap. Shrink the plate about the belt axis until its whole outline
     lies inside the strap silhouette, pulled in by a fixed margin of hide.
     ------------------------------------------------------------------ */
  var LEATHER_MARGIN = 17;

  function pointIn(poly, x, y) {
    var ins = false, i, j;
    for (i = 0, j = poly.length - 1; i < poly.length; j = i++) {
      var xi = poly[i][0], yi = poly[i][1], xj = poly[j][0], yj = poly[j][1];
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) ins = !ins;
    }
    return ins;
  }
  function pathInside(path, cx, cy, kx, ky, hull) {
    var pts = flatten(path.scale(cx, cy, kx, ky), 5), i;
    for (i = 0; i < pts.length; i++) if (!pointIn(hull, pts[i][0], pts[i][1])) return false;
    return true;
  }
  function fitInsideHull(path, cx, cy, hull) {
    if (pathInside(path, cx, cy, 1, 1, hull)) return path;
    /* Height first: a plate is nearly always too tall for the taper of the
       yoke rather than too wide, and squeezing height keeps the silhouette
       the customer picked recognisable. */
    var lo = 0.55, hi = 1.0, mid, i;
    for (i = 0; i < 18; i++) {
      mid = (lo + hi) / 2;
      if (pathInside(path, cx, cy, 1, mid, hull)) lo = mid; else hi = mid;
    }
    if (lo > 0.80) return path.scale(cx, cy, 1, lo);
    /* Still not fitting on height alone — take it down uniformly instead. */
    lo = 0.55; hi = 1.0;
    for (i = 0; i < 18; i++) {
      mid = (lo + hi) / 2;
      if (pathInside(path, cx, cy, mid, mid, hull)) lo = mid; else hi = mid;
    }
    return path.scale(cx, cy, lo, lo);
  }

  function build(tplId, layers) {
    var t = null, i;
    for (i = 0; i < TEMPLATES.length; i++) if (TEMPLATES[i].id === tplId) t = TEMPLATES[i];
    if (!t) t = TEMPLATES[0];
    var n = Math.max(1, Math.min(4, layers || 1));

    var b = { cx: CX, cy: CY, hw: t.hw, hh: t.hh };
    var centre = CENTRES[t.id](b);
    /* the plate is never clipped: the hide is cut to it further down, so the
       tiers, the field, the ornament and the text zones all keep the size the
       chosen silhouette was designed at */
    var cb = centre.bbox();

    /* Side plates. On a real belt each side plate is a separate casting resting
       on the strap with clear leather showing between it and its neighbours —
       they are never butted together. The gaps are therefore fixed first and
       the plates are sized to whatever room is left, rather than the plates
       being sized first and the gaps squeezed out to make them fit. */
    var GAP_C = 44;      // leather between the centre plate and the inner plate
    var GAP_S = 38;      // leather between the inner plate and the outer plate
    var RUN_END = 1292;  // the keeper starts at 1290 — nothing may reach it
    /* A side plate is screwed to the strap between the two rows of saddle
       stitching, never across them: the inner run sits 24 units in from the
       leather edge, so the tallest a side plate may be is that, less a margin
       of hide. This is what keeps the arms of the belt straight and every
       flanking plate visibly inside the threading. */
    var SIDE_MAX_HH = BH - 24 - 7;
    var innerHw = 64, innerHh = 66, outerHw = 58, outerHh = 60;
    var room = RUN_END - (cb.x + cb.w) - GAP_C - GAP_S;
    var want = 2 * innerHw + 2 * outerHw;
    var k = Math.min(1, room / want);
    if (k < 0.78) k = 0.78;
    innerHw *= k; innerHh *= k; outerHw *= k; outerHh *= k;
    innerHh = Math.min(innerHh, SIDE_MAX_HH);
    outerHh = Math.min(outerHh, SIDE_MAX_HH);
    var innerCx = cb.x + cb.w + GAP_C + innerHw;
    var outerCx = innerCx + innerHw + GAP_S + outerHw;
    var sideFn = SIDES[t.side] || SIDES.rounded, outFn = SIDES[t.outer] || SIDES.rounded;
    var pInnerR = sideFn(innerCx, CY, innerHw, innerHh);
    var pOuterR = outFn(outerCx, CY, outerHw, outerHh);

    var plates = {
      center: { key: 'center', path: centre, box: cb, z: 3, side: false, maxLayers: 4 },
      innerL: { key: 'innerL', path: pInnerR.mirror(), box: pInnerR.mirror().bbox(), z: 2, side: true, maxLayers: 3 },
      innerR: { key: 'innerR', path: pInnerR, box: pInnerR.bbox(), z: 2, side: true, maxLayers: 3 },
      outerL: { key: 'outerL', path: pOuterR.mirror(), box: pOuterR.mirror().bbox(), z: 1, side: true, maxLayers: 2 },
      outerR: { key: 'outerR', path: pOuterR, box: pOuterR.bbox(), z: 1, side: true, maxLayers: 2 }
    };

    /* --- tiers, ornament field, zones --- */
    Object.keys(plates).forEach(function (key) {
      var pl = plates[key];
      var pn = Math.min(n, pl.maxLayers);
      pl.layers = pn;
      pl.tiers = layerOutlines(pl, pn);
      var tt = topTier(pl, pn);
      pl.top = tt;
      var tpoly = flatten(tt.path, 8);
      var bpoly = flatten(pl.path, 8);
      pl.topPoly = tpoly;

      if (key === 'center') {
        /* the plate face: an outer metal frame, then a recessed enamel field that
           carries the medallion, the ornament and the two inner lines */
        var fIns = pn > 1 ? 15 : FIELD_INSET;
        var field = insetPath(tt.path, tt.box, fIns);
        var fpoly = flatten(field, 6), fb = trueBox(fpoly);
        pl.field = { path: field, box: fb, inset: fIns };
        var bTrue = trueBox(bpoly), tTrue = trueBox(tpoly);
        var bhh = bTrue.h / 2, thh = tTrue.h / 2, fhh = fb.h / 2;
        var wideB = maxSpan(bpoly, bTrue.cy, bhh), wideF = maxSpan(fpoly, fb.cy, fhh);

        /* medallion: big, like a real title belt, but always inside the field */
        var mr = 0.44 * Math.min(fhh, wideF * 0.48);
        pl.art = { cx: fb.cx, cy: fb.cy + fhh * 0.015, r: mr, plateR: Math.min(wideF, fb.h) * 0.47 };

        /* zones 1 + 4 ride the BASE tier frame, outside the top tier */
        /* keep the outer banners a full banner-height clear of the plate edge:
           the arc bows them outwards, and a bowed ribbon whose ends clear the
           rim but whose crown does not is the classic "sticker on the leather"
           look this build must not have */
        var ringOut = bhh - 16;
        var ringIn = tt.inset ? thh + 6 : bhh * 0.44;
        var z1h = Math.max(22, Math.min(33, (ringOut - ringIn) * 0.94));
        var z23h = Math.max(17, Math.min(36, fhh * 0.21));
        var hi14 = ringOut - z1h / 2, lo14 = Math.min(ringIn + z1h / 2, hi14);
        /* the inner pair stays clear of the outer pair: on a single-layer plate
           the two rings are the same surface, and two bands touching reads as
           one muddled block rather than two struck plaques */
        var s = [];
        /* the outer banners are the only metal that sits near the plate's edge,
           and every banner style flares a tail past its own box — so they are
           padded in far enough that even the widest tail stays on the plate
           instead of running out over the leather */
        /* an arced banner bows its crown outward past its own box, so the band
           is first pulled in by the bow — otherwise the ends sit on the plate
           and the middle rides up over the leather */
        var bw1 = t.arc ? z1h * 0.26 : 0, bw4 = t.arc ? z1h * 0.24 : 0;
        /* Zones 1 and 4 belong on the ring of the BASE tier, outside the top
           tier — that is where a real belt carries its outer plaques. On a
           spiky or narrow silhouette that ring has no room for a band, and
           rather than let one hang over the edge we drop it onto the top tier
           instead. Either way the band ends up ON a surface, which is what
           stops it looking like it is floating. */
        var tierOf = {};
        function outerBand(id, dir, bow) {
          var sl = null;
          if (tt.inset > 6) {
            sl = placeSlot(id, 'center', bpoly, bTrue.cy, dir, Math.min(thh + 8 + z1h / 2, hi14), hi14, z1h, t.arc, bow, 34, bTrue.cx);
            if (sl) { tierOf[id] = 0; return sl; }
          }
          sl = placeSlot(id, 'center', tpoly, tTrue.cy, dir, thh * 0.34, thh - 10 - z1h / 2, z1h, t.arc, bow, 26, tTrue.cx);
          if (sl) { tierOf[id] = pn - 1; return sl; }
          return null;
        }
        var s1 = outerBand('1', -1, bw1);
        var s4 = outerBand('4', 1, -bw4);
        /* the inner pair is then fitted in the room the outer pair actually
           left, so two bands can never sit on top of one another */
        var low1 = s1 ? s1.y + s1.h + (s1.bow < 0 ? Math.abs(s1.bow) : 0) : -1e9;
        var high4 = s4 ? s4.y - (s4.bow > 0 ? Math.abs(s4.bow) : 0) : 1e9;
        var hi2 = Math.min(fhh * 0.70, fb.cy - low1 - 15 - z23h / 2);
        var hi3 = Math.min(fhh * 0.68, high4 - 15 - fb.cy - z23h / 2);
        var s2 = hi2 >= fhh * 0.16 ? placeSlot('2', 'center', fpoly, fb.cy, -1, fhh * 0.16, hi2, z23h, false, 0, 12, fb.cx, 40) : null;
        var s3 = hi3 >= fhh * 0.16 ? placeSlot('3', 'center', fpoly, fb.cy, 1, fhh * 0.16, hi3, z23h, false, 0, 12, fb.cx, 40) : null;
        s.push(s1); s.push(s2); s.push(s3); s.push(s4);
        pl.slots = s.filter(Boolean);
        pl.slotTier = { '1': tierOf['1'] === undefined ? pn - 1 : tierOf['1'],
                        '4': tierOf['4'] === undefined ? pn - 1 : tierOf['4'],
                        '2': pn - 1, '3': pn - 1 };
        pl.slotField = { '2': 1, '3': 1 };
      } else {
        var tTrue2 = trueBox(tpoly);
        var field2 = insetPath(tt.path, tt.box, SIDE_FIELD_INSET);
        var fp2 = flatten(field2, 5), fb2 = trueBox(fp2);
        pl.field = { path: field2, box: fb2, inset: SIDE_FIELD_INSET };
        var fh2 = fb2.h / 2, wide2 = maxSpan(fp2, fb2.cy, fh2);
        pl.art = { cx: fb2.cx, cy: fb2.cy - fh2 * 0.16, r: 0.46 * Math.min(fh2 * 0.92, wide2 * 0.46), plateR: Math.min(wide2, fb2.h) * 0.47 };
        var id = key === 'innerL' ? 'L' : key === 'innerR' ? 'R' : key === 'outerL' ? 'OL' : 'OR';
        var zh2 = Math.max(15, Math.min(24, fh2 * 0.36));
        var sl = placeSlot(id, key, fp2, fb2.cy, 1, fh2 * 0.24, fh2 * 0.76, zh2, false, 0, 6, fb2.cx, 30, true);
        var onField = 1;
        if (!sl) {
          /* a deeply stacked side plate has almost no recessed field left, so
             the nameplate sits on the tier face itself rather than nowhere */
          var th2 = tTrue2.h / 2, zh3 = Math.max(13, Math.min(20, th2 * 0.30));
          sl = placeSlot(id, key, tpoly, tTrue2.cy, 1, th2 * 0.20, th2 - 7 - zh3 / 2, zh3, false, 0, 5, tTrue2.cx, 28, true);
          onField = 0;
        }
        pl.slots = sl ? [sl] : [];
        pl.slotTier = {}; pl.slotTier[id] = pn - 1;
        pl.slotField = {}; if (onField) pl.slotField[id] = 1;
      }
    });

    /* cut the hide to the plates: the centre plate gets the full leather border,
       the four side plates only a clearance, so the arms stay straight unless a
       side plate would otherwise run off the edge of the strap */
    var obst = [{ poly: flatten(centre, 3), m: HIDE_M }];
    ['innerL', 'innerR', 'outerL', 'outerR'].forEach(function (k) {
      obst.push({ poly: flatten(plates[k].path, 3), m: HIDE_MS });
    });

    return {
      id: t.id, name: t.name, desc: t.desc, arc: t.arc, yoke: t.yoke, layers: n,
      plates: plates, strap: strapGeom(t, obst), W: W, H: H, CX: CX, CY: CY, BH: BH
    };
  }

  /* rim outline for a plate (inset copy used as the polished bevel) */
  function rim(plate, inset) {
    var b = plate.box, k = 1 - (inset || 0.055);
    return plate.path.scale(b.cx, b.cy, k, k);
  }

  /* =========================================================================
     12 FRONT-PLATE ORNAMENT LAYOUTS
     Every layout is authored inside a unit disc of radius `r` around (cx, cy)
     and is capped at `maxR` so it can never leave the tier it is drawn on.
     ========================================================================= */
  function layout(id, art) {
    var cx = art.cx, cy = art.cy, r = art.r, g = [];
    var maxR = (art.plateR || r * 2.4) * 0.94;
    function add(d, kind, w) { g.push({ d: d, kind: kind || 'fill', w: w || 0 }); }
    function R(k) { return Math.min(r * k, maxR); }
    var i, j, a, x, y;

    if (id === 'crest') {
      add(circlePath(cx, cy, R(1.24)).svg(), 'stroke', r * 0.085);
      var lf = P();
      for (i = 0; i < 8; i++) {
        a = (-66 + i * 132 / 7) * Math.PI / 180;
        [-1, 1].forEach(function (s) {
          var rr = R(1.50), px = cx + s * rr * Math.cos(a), py = cy + rr * Math.sin(a);
          lf.M(px, py - r * 0.21).Q(px + r * 0.11 * s, py, px, py + r * 0.21).Q(px - r * 0.11 * s, py, px, py - r * 0.21).Z();
        });
      }
      add(lf.svg());
      add(star(cx, cy - R(1.62), r * 0.20).svg());
    } else if (id === 'shield') {
      var w = R(1.44), top = cy - R(1.38), bot = cy + R(1.56);
      add(P().M(cx - w, top).L(cx + w, top).L(cx + w, bot - r * 0.80).Q(cx + w, bot - r * 0.06, cx, bot).Q(cx - w, bot - r * 0.06, cx - w, bot - r * 0.80).Z().svg(), 'stroke', r * 0.11);
      add(P().M(cx - w * 0.80, top + r * 0.16).L(cx + w * 0.80, top + r * 0.16).L(cx + w * 0.80, bot - r * 0.88).Q(cx + w * 0.80, bot - r * 0.24, cx, bot - r * 0.18).Q(cx - w * 0.80, bot - r * 0.24, cx - w * 0.80, bot - r * 0.88).Z().svg(), 'stroke', r * 0.03);
    } else if (id === 'starburst') {
      var rays = P(), ri = R(1.08), ro = R(1.58);
      for (j = 0; j < 24; j++) {
        var a0 = j * 15 * Math.PI / 180, a1 = (j * 15 + 6.2) * Math.PI / 180;
        rays.M(cx + ri * Math.cos(a0), cy + ri * Math.sin(a0)).L(cx + ro * Math.cos(a0), cy + ro * Math.sin(a0))
          .L(cx + ro * Math.cos(a1), cy + ro * Math.sin(a1)).L(cx + ri * Math.cos(a1), cy + ri * Math.sin(a1)).Z();
      }
      add(rays.svg());
      add(circlePath(cx, cy, R(1.12)).svg(), 'stroke', r * 0.07);
    } else if (id === 'rope') {
      var rope = P(), n1 = 42, R2 = R(1.22);
      for (i = 0; i < n1; i++) { a = i * 2 * Math.PI / n1; rope.add(circlePath(cx + R2 * Math.cos(a), cy + R2 * Math.sin(a), r * 0.105)); }
      add(rope.svg());
      add(circlePath(cx, cy, R(1.02)).svg(), 'stroke', r * 0.035);
    } else if (id === 'gems') {
      var gm = P(), R3 = R(1.32);
      for (i = 0; i < 12; i++) {
        a = (i * 30 - 90) * Math.PI / 180; x = cx + R3 * Math.cos(a); y = cy + R3 * Math.sin(a);
        var s3 = i % 3 === 0 ? r * 0.19 : r * 0.12;
        gm.add(poly([[x, y - s3], [x + s3, y], [x, y + s3], [x - s3, y]]));
      }
      add(gm.svg());
      add(circlePath(cx, cy, R(1.08)).svg(), 'stroke', r * 0.05);
    } else if (id === 'deco') {
      var dc = P();
      for (i = 0; i < 5; i++) {
        var yy = cy - R(1.44) + i * R(0.72), ww = R(1.62 - Math.abs(i - 2) * 0.17);
        dc.add(poly([[cx - ww, yy], [cx + ww, yy], [cx + ww - r * 0.12, yy + r * 0.09], [cx - ww + r * 0.12, yy + r * 0.09]]));
      }
      add(dc.svg());
      add(P().M(cx - R(1.64), cy - R(1.50)).L(cx - R(1.36), cy - R(1.50)).L(cx - R(1.64), cy + R(1.50)).Z().svg());
      add(P().M(cx + R(1.64), cy - R(1.50)).L(cx + R(1.36), cy - R(1.50)).L(cx + R(1.64), cy + R(1.50)).Z().svg());
    } else if (id === 'wreath') {
      var wr = P();
      for (i = 0; i < 10; i++) {
        a = (-72 + i * 144 / 9) * Math.PI / 180;
        [-1, 1].forEach(function (s) {
          var rr = R(1.42), px = cx + s * rr * Math.cos(a), py = cy + rr * Math.sin(a);
          wr.add(poly([[px, py - r * 0.17], [px + r * 0.09 * s, py - r * 0.03], [px, py + r * 0.17], [px - r * 0.06 * s, py - r * 0.02]]));
        });
      }
      add(wr.svg());
      add(star(cx, cy - R(1.60), r * 0.17).svg());
    } else if (id === 'globe') {
      /* a meridian globe inside a laurel sweep — the classic world-title face */
      var RR = R(1.06), lw = Math.max(1.4, r * 0.035);
      add(circlePath(cx, cy, RR).svg(), 'stroke', r * 0.085);
      for (i = 1; i <= 3; i++) {                                  /* parallels */
        var lat = i * 0.26, rx = RR * Math.sqrt(Math.max(0.03, 1 - lat * lat));
        add(ellipsePath(cx, cy - RR * lat, rx, RR * 0.085).svg(), 'stroke', lw);
        add(ellipsePath(cx, cy + RR * lat, rx, RR * 0.085).svg(), 'stroke', lw);
      }
      add(P().M(cx - RR, cy).L(cx + RR, cy).svg(), 'stroke', lw * 1.3);
      for (i = 1; i <= 2; i++) add(ellipsePath(cx, cy, RR * Math.cos(i * Math.PI / 6), RR).svg(), 'stroke', lw);
      add(P().M(cx, cy - RR).L(cx, cy + RR).svg(), 'stroke', lw);
      var gw = P();
      for (i = 0; i < 8; i++) {
        a = (18 + i * 144 / 7) * Math.PI / 180;
        [-1, 1].forEach(function (s) {
          var rr = R(1.42), px = cx + s * rr * Math.cos(a), py = cy + rr * Math.sin(a);
          gw.add(poly([[px, py - r * 0.16], [px + r * 0.085 * s, py - r * 0.02], [px, py + r * 0.16], [px - r * 0.055 * s, py - r * 0.01]]));
        });
      }
      add(gw.svg());
    } else if (id === 'wings') {
      var wg = P();
      [-1, 1].forEach(function (s) {
        for (i = 0; i < 6; i++) {
          var t2 = i / 5;
          var xa = cx + s * R(1.02 + t2 * 0.56);
          var ya = cy - R(0.28) + t2 * t2 * R(0.34);
          var ln2 = r * (0.54 - t2 * 0.19);
          wg.add(P().M(xa, ya - ln2 * 0.34)
            .Q(xa + s * r * 0.30, ya + ln2 * 0.08, xa + s * r * 0.10, ya + ln2)
            .Q(xa - s * r * 0.11, ya + ln2 * 0.34, xa - s * r * 0.05, ya - ln2 * 0.30).Z());
        }
      });
      add(wg.svg());
      add(circlePath(cx, cy, R(1.02)).svg(), 'stroke', r * 0.075);
      add(star(cx, cy - R(1.36), r * 0.19).svg());
    } else if (id === 'chain') {
      var n2 = 18, RC = R(1.24), lw2 = Math.max(1.6, r * 0.055);
      for (i = 0; i < n2; i++) {
        a = i * 2 * Math.PI / n2;
        x = cx + RC * Math.cos(a); y = cy + RC * Math.sin(a);
        add(rot(ellipsePath(x, y, r * 0.19, r * 0.115), x, y, a + Math.PI / 2).svg(), 'stroke', lw2);
      }
      add(circlePath(cx, cy, R(1.02)).svg(), 'stroke', r * 0.04);
    } else if (id === 'laurelcrown') {
      var lc = P();
      for (i = 0; i < 7; i++) {
        a = (-84 + i * 168 / 6) * Math.PI / 180;
        [-1, 1].forEach(function (s) {
          var rr = R(1.36), px = cx + s * rr * Math.cos(a), py = cy + rr * Math.sin(a);
          lc.add(ellipsePath(px, py, r * 0.07, r * 0.20));
        });
      }
      add(lc.svg());
      var crown = P().M(cx - R(0.66), cy - R(1.34)).L(cx - R(0.46), cy - R(1.62)).L(cx - R(0.22), cy - R(1.40))
        .L(cx, cy - R(1.62)).L(cx + R(0.22), cy - R(1.40)).L(cx + R(0.46), cy - R(1.62)).L(cx + R(0.66), cy - R(1.34)).Z();
      add(crown.svg());
      add(circlePath(cx, cy, R(1.06)).svg(), 'stroke', r * 0.06);
    } else if (id === 'fluted') {
      var fl = P(), n3 = 32;
      for (i = 0; i < n3; i++) {
        var b0 = i * 2 * Math.PI / n3, b1 = b0 + 2 * Math.PI / n3 * 0.46;
        var r0 = R(1.06), r1 = R(1.50);
        fl.M(cx + r0 * Math.cos(b0), cy + r0 * Math.sin(b0)).L(cx + r1 * Math.cos(b0), cy + r1 * Math.sin(b0))
          .L(cx + r1 * Math.cos(b1), cy + r1 * Math.sin(b1)).L(cx + r0 * Math.cos(b1), cy + r0 * Math.sin(b1)).Z();
      }
      add(fl.svg());
      add(circlePath(cx, cy, R(1.56)).svg(), 'stroke', r * 0.055);
      add(circlePath(cx, cy, R(1.02)).svg(), 'stroke', r * 0.055);
    } else if (id === 'wreathlet') {
      var wl = P();
      for (i = 0; i < 7; i++) {
        a = (-70 + i * 140 / 6) * Math.PI / 180;
        [-1, 1].forEach(function (s) {
          var rr = R(1.24), px = cx + s * rr * Math.cos(a), py = cy + rr * Math.sin(a);
          wl.add(poly([[px, py - r * 0.20], [px + r * 0.10 * s, py], [px, py + r * 0.20], [px - r * 0.07 * s, py]]));
        });
      }
      add(wl.svg());
      add(star(cx, cy - R(1.36), r * 0.20).svg());
    } else if (id === 'starmark') {
      /* one clean struck star inside a turned ring — reads at flanking-plate size */
      add(circlePath(cx, cy, R(1.30)).svg(), 'stroke', r * 0.10);
      add(star(cx, cy, R(1.02), 5).svg());
    } else { /* minimal */
      add(circlePath(cx, cy, R(1.14)).svg(), 'stroke', r * 0.07);
      add(circlePath(cx, cy, R(1.34)).svg(), 'stroke', r * 0.025);
    }
    return g;
  }

  var LAYOUTS = [
    { id: 'crest', name: 'Classic Crest', desc: 'Laurel ring with a crown star above the medallion.' },
    { id: 'globe', name: 'World Globe', desc: 'Meridian globe grid — the world-title look.' },
    { id: 'shield', name: 'Royal Shield', desc: 'Double shield frame around the medallion.' },
    { id: 'starburst', name: 'Laurel Starburst', desc: 'Radiating rays behind the emblem.' },
    { id: 'wreath', name: 'Wreath & Star', desc: 'Olive wreath with a single crown star.' },
    { id: 'laurelcrown', name: 'Laurel Crown', desc: 'Full laurel with a five-point crown.' },
    { id: 'wings', name: 'Spread Wings', desc: 'Feathered wings sweeping out of the bezel.' },
    { id: 'rope', name: 'Rope Bezel', desc: 'Beaded rope ring, heavy and traditional.' },
    { id: 'chain', name: 'Chain Bezel', desc: 'Interlocking links around the medallion.' },
    { id: 'gems', name: 'Gem Setting', desc: 'Twelve faceted stones around the medallion.' },
    { id: 'fluted', name: 'Fluted Sunburst', desc: 'Machined flutes between two turned rings.' },
    { id: 'deco', name: 'Art Deco', desc: 'Stepped bars and corner fins.' },
    { id: 'minimal', name: 'Minimal Ring', desc: 'Two clean rings — lets big artwork breathe.' }
  ];

  root.ZBGeom = {
    W: W, H: H, CX: CX, CY: CY, BH: BH, X0: X0, X1: X1, YOKE_W: YOKE_W, YOKE_H: YOKE_H,
    Path: Path, P: P, build: build, rim: rim, layerOutlines: layerOutlines, topTier: topTier,
    TEMPLATES: TEMPLATES, LAYOUTS: LAYOUTS, BANNERS: BANNERS, BANNER_HAS_FILL: BANNER_HAS_FILL,
    TIER_INSET: TIER_INSET, SIDE_TIER_INSET: SIDE_TIER_INSET,
    layout: layout, circlePath: circlePath, ellipsePath: ellipsePath, star: star, roundRect: roundRect,
    poly: poly, ngon: ngon, flatten: flatten, spanAt: spanAt, spanRun: spanRun, mkSlot: mkSlot, strapOutline: strapOutline, hideOutline: hideOutline, offsetPath: offsetPath,
    trueBox: trueBox, maxSpan: maxSpan, insetPath: insetPath, FIELD_INSET: FIELD_INSET,
    bannerShape: function (slot, style) { var fn = BANNERS[style] || BANNERS.ribbon; return fn(slot); },
    textPath: function (slot, style) {
      var yb = slot.y + slot.h * 0.74;
      if (style === 'arch') { var bow = slot.arc ? Math.abs(slot.bow) : Math.max(12, slot.h * 0.6); return P().M(slot.x0 + 8, slot.y + slot.h - 3).Q(slot.cx, slot.y - bow * 0.60 + slot.h, slot.x1 - 8, slot.y + slot.h - 3); }
      if (slot.arc && (style === 'ribbon' || style === 'none')) return P().M(slot.x0 + 8, yb).Q(slot.cx, yb - slot.bow, slot.x1 - 8, yb);
      return P().M(slot.x0 + 8, yb).L(slot.x1 - 8, yb);
    }
  };
})(typeof window !== 'undefined' ? window : globalThis);
